import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const DocumentLanguageSync = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const applyLanguage = (lng) => {
      const lang = lng && lng.startsWith('en') ? 'en' : 'fr';
      document.documentElement.lang = lang;
    };

    applyLanguage(i18n.language);
    i18n.on('languageChanged', applyLanguage);

    return () => {
      i18n.off('languageChanged', applyLanguage);
    };
  }, [i18n]);

  return null;
};

export default DocumentLanguageSync;
